import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { tourismClassifiedAPIRoutes } from '..';

// Define a service using a base URL and expected endpoints
/**
 * fileUploadServices is a collection of API endpoints for user management.
 */
export const fileUploadServices = createApi({
  reducerPath: 'fileUploadServices',
  tagTypes: ['FileUploadTag'],
  baseQuery: fetchBaseQuery({
    baseUrl: tourismClassifiedAPIRoutes.baseUrl,

    prepareHeaders: (headers) => {
      // If we have a token set in local storage, let's assume that we should be passing it.
      const token = localStorage.getItem('jwtToken');
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      return headers;
    }
  }),
  endpoints: (builder) => ({
    deleteFile: builder.mutation<void, string>({
      query: (id) => ({
        url: `${tourismClassifiedAPIRoutes.fileUpload.endpoint}/${tourismClassifiedAPIRoutes.fileUpload.delete}?vendorDocumentDetailId=${id}`,
        method: 'DELETE'
      }),
      invalidatesTags: ['FileUploadTag']
    }),
    uploadFile: builder.mutation<
      void,
      {
        documentType: string;
        vendorId: number;
        body: FormData;
      }
    >({
      query: ({ documentType, vendorId, body }) => ({
        url: `${tourismClassifiedAPIRoutes.fileUpload.endpoint}/${tourismClassifiedAPIRoutes.fileUpload.upload}/${documentType}/${vendorId}`,
        method: 'POST',
        body
      }),
      invalidatesTags: ['FileUploadTag']
    })
  })
});

export const { useDeleteFileMutation, useUploadFileMutation } =
  fileUploadServices;
